export default "__VITE_ASSET__e1e51805__"